<nav class="navbar navbar-expand-lg navbar-light bg-danger p-2" >
    <img src="assets/logo.png" class="logo" alt="ChatApp"> 
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  
  <div class="collapse navbar-collapse">
    <ul class="navbar-nav  ">
        <li class="nav-item">
            <a class="nav-link h2"  href="#"><b><span style="color:white">Chat</span><span>app</span></b></a>
          </li>
      <!-- <li class="nav-item">
        <a class="nav-link" routerLink='login' href="#">Login</a>
      </li> -->
      <!-- <li class="nav-item">
        <a class="nav-link" routerLink='register' href="#">Register</a>
      </li> -->
      
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <!-- <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"> -->
    </form>
  </div>
</nav>

<div  id="home">
 <div class="row " id="container">
   <div class="col-md-4 offset-2">
     <p class="h1">Simple. Secure.<br>
    Reliable messaging.</p>
     <p>With ChatApp, you'll get fast, simple, secure messaging <br>
      and calling for free*, available on phones all over the world.</p>
        <button class="btn btn ml-5" style="background-color:pink; border-radius: 10px"  (click)="getStarted()">Get Started</button>     
   </div>
   <div class="col-md-5 offset-1" id="images">
 <img src="assets/07.jpg">
 </div>
 </div>
</div>

<div class="row" style="">
  <div class="col-md-6 col-6" style="background-color:#6A73B8; color: white">
    <div class="m-5 text-center">
    <p class="h3 ">ChatApp Business App</p><br>
    <p><a href="" >ChatApp Business </a> is a free to download app that was built with the small business owner in mind.
       Create a catalog to showcase your products and services.
       Connect with your customers easily by using tools to automate, sort and quickly respond to messages.</p><br><br>

       <p>ChatApp can also help medium and large businesses provide customer support  and deliver important notifications
          to customers. Learn more about <a href="">WhatsApp Business API.</a> </p>
  </div>
  <img src="assets/22.png" style="margin-left:25%">
      </div>
  <div class="col-md-6 col-6 ">
    <div class="" align="center">
         <img src="assets/love 11.jpg" style="margin-top:0px; " >
    </div>     
  </div>
</div>

<div class="row">
 <div class="col-md-12 col-12" style="background-color:white; height:15px">

 </div>
</div>


<div class="footer">
    <section  class="offset container-fluid bg-dark" style="height:330px">
        <br>
        <br>
        <div class="row mt-5">
          
  
  <br><br>
        <div class="container">
        <div class="row ">
          <div class="col-md-3 col-sm-12 text-center ">
             <div class="h4"><b><span style="color:red">CHAT</span><span>APP</span></b></div><br>
             <div class="text-light">
              <span class="col"><a href="" style="color:grey">Security</a></span><br><br>
  
            <span class="col"><a href="" style="color:grey">Business</a></span><br><br>
  
              <span class="col"><a href="" style="color:grey"> Privacy</a></span><br><br>        
          </div>
            </div>
  
            
            <div class="col-md-3 col-sm-12 text-center text-light">
              <div class="h4"><b>COMPANY</b></div><br>
             <span class="col"><a href="" style="color:grey">About </a></span><br><br>
              
            <span class="col"><a href="" style="color:grey">Brand Center</a></span><br><br> 
            </div>
            
              <div class="col-md-3 col-sm-12 text-center text-light">
                  <div class="h4"><b>DOWNLOAD</b></div><br>
                 <span class="col" ><a href="" style="color:grey">Mac/PC</a></span><br><br>
                  
                <span class="col"><a href="" style="color:grey">Android</a></span><br><br>
                  
                <span class="col"><a href="" style="color:grey"> iPhone</a></span><br><br> 
                </div>
           
                <div class="col-md-3 col-sm-12 text-center text-light">
                        <div class="h4"><b>HELP</b></div><br>
                       <span class="col"><a href="" style="color:grey">Faceboook</a></span><br><br>
           
                     <span class="col"><a href="" style="color:grey">Twitter</a></span><br><br>
                    </div>
   <br>
          
      </div>
    </div>
<br><br><br><br>
<div class="col-md-12 col-12 text-center">
  <p class="h4 pt-3" style="color: #585FA5"> © ChatApp.Inc</p>
</div>

      </div>
      </section>
  </div>